/* eslint-disable no-unused-vars */
import { API_DOMAIN, API_DOMAIN_LOCAL, API_ENDPOINT_BASE_DOKAN } from '../ApiEnv';

// Order Api
export const ordersAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/orders`;
export const orderSummaryAPI = `${ordersAPI}/summary`;
export const orderDetails = `${ordersAPI}/:id`;
